const defaultOptions = {
  strOrFn: '',
  tableData: [],
  font: '14px Arial',
  minWidth: 80,
}

export function flexColumnWidth(options = {}) {
  const { strOrFn, tableData, font, minWidth } = {
    ...defaultOptions,
    ...options,
  }

  // 如果数据源或列名为空，直接返回
  if (!tableData || !tableData.length || !strOrFn) return

  let columnContent = ''

  for (let i = 0; i < tableData.length; i++) {
    if (typeof strOrFn === 'string' && !tableData[i][strOrFn]) {
      // 如果是字符串且对应的列数据不存在，跳过
      continue
    }

    let content = ''

    if (typeof strOrFn === 'function') {
      // 如果是函数，调用函数获取内容
      content = strOrFn(tableData[i])
    } else {
      // 如果是字符串，直接获取对应列的数据
      content = tableData[i][strOrFn] ? tableData[i][strOrFn].toString() : ''
    }

    if (content.length > columnContent.length) {
      columnContent = content
    }
  }

  // 如果没有获取到合适的内容，返回
  if (!columnContent) return

  // 计算文本宽度，并添加 padding 和边框的宽度
  let textWidth = getTextWidth(columnContent, font)
  const padding = 24 + 2
  const totalWidth = Math.ceil(textWidth + padding)

  if (totalWidth < minWidth) return `${minWidth}`

  return `${totalWidth}`
}

// 计算文本宽度的函数，使用 canvas 渲染文本来测量宽度
function getTextWidth(text, font) {
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')
  if (context) {
    context.font = font // 设置字体
    return context.measureText(text).width // 返回测量的宽度
  }
  return 0
}
